import React from "react"
import DateHelper from "../../DateHelper/DateHelper"

class ScheduledDateDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data) {
      var data_date = DateHelper.parseDate(this.props.data);
      var now = new Date();
      var finished_at = DateHelper.parseDate(this.props.row.finished_at)
      
      now.setHours(0,0,0,0)
      if(finished_at != null){
        finished_at.setHours(0,0,0,0)
      }

      return <div>{data_date.toString(DateHelper.rubyToDateJS(this.props.date_format))}</div>
    } else {
      return (
        <em className="text-center">&nbsp;</em>
      );
    }
  }

};

export default ScheduledDateDataType